import type { WorkflowSession } from "./types";
import type { WorkflowAgent } from "./types";
import { formatDate } from "./sessionDetailHelpers";
import styles from "./workflow.module.scss";

interface Props {
  session: WorkflowSession;
  agents: WorkflowAgent[];
  agentAssignFlash: boolean;
  isAgentSaving: boolean;
  onAgentAssign: (agentId: string) => void;
}

const SessionMetaGrid = ({
  session,
  agents,
  agentAssignFlash,
  isAgentSaving,
  onAgentAssign,
}: Props) => (
  <div className={styles.sessionMeta}>
    <div className={styles.metaGrid}>
      {session.title && (
        <div className={styles.metaItem}>
          <span className={styles.metaLabel}>Title</span>
          <span>{session.title}</span>
        </div>
      )}
      <div className={styles.metaItem}>
        <span className={styles.metaLabel}>Priority</span>
        <span>{session.priority ?? "medium"}</span>
      </div>
      <div className={styles.metaItem}>
        <span className={styles.metaLabel}>Channel</span>
        <span>{session.channel ?? "-"}</span>
      </div>
      {session.assignee && (
        <div className={styles.metaItem}>
          <span className={styles.metaLabel}>Assignee</span>
          <span>{session.assignee}</span>
        </div>
      )}
      {session.created_by && (
        <div className={styles.metaItem}>
          <span className={styles.metaLabel}>Created By</span>
          <span>{session.created_by}</span>
        </div>
      )}
      {session.created_at && (
        <div className={styles.metaItem}>
          <span className={styles.metaLabel}>Created</span>
          <span>{formatDate(session.created_at)}</span>
        </div>
      )}
      {session.completed_at && (
        <div className={styles.metaItem}>
          <span className={styles.metaLabel}>Completed</span>
          <span>{formatDate(session.completed_at)}</span>
        </div>
      )}
      {session.next_action && (
        <div className={styles.metaItem}>
          <span className={styles.metaLabel}>Next Action</span>
          <span>{session.next_action}</span>
        </div>
      )}
      <div className={styles.metaItem}>
        <label htmlFor="agent-select" className={styles.metaLabel}>
          AI Agent
          <div className={styles.agentSelectWrapper}>
            <select
              id="agent-select"
              className={`${styles.agentSelect} ${agentAssignFlash ? styles.agentAssignSuccess : ""}`}
              value={session.current_agent_id ?? ""}
              onChange={e => onAgentAssign(e.target.value)}
              disabled={isAgentSaving}
            >
              <option value="">Unassigned (Generic)</option>
              {agents.map(a => (
                <option key={a.id} value={a.id}>
                  {a.name}
                </option>
              ))}
            </select>
            {isAgentSaving && <span className={styles.agentSaving}>Saving...</span>}
            {agentAssignFlash && <span className={styles.agentSaved}>Saved</span>}
          </div>
        </label>
      </div>
    </div>
  </div>
);

export default SessionMetaGrid;
